import { useContext } from 'react'
import { Link } from '@/components/Link'
import { URL_DPV_REGISTER } from '@/config/account'
import { AccountContext } from '@/context/AccountContextDpv'
import { useDpvAboLink } from '@/hooks/useDpvAboLink'
import Popup from '@/components/Popup/Popup'
import { Typography } from '@/components/Typography'
import styles from '../LoginPopup/LoginPopup.module.scss'

const LoginPopup = ({
  isOpen,
  setIsOpen,
}: {
  isOpen?: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const accountContext = useContext(AccountContext)
  const dpvAboLink = useDpvAboLink()

  const onAgree = () => {
    window.open(accountContext?.liUrl, '_self')
    setIsOpen(false)
  }
  const createAcc = () => {
    window.open(URL_DPV_REGISTER, '_blank')
    setIsOpen(false)
  }

  return (
    <>
      {isOpen && (
        <Popup title="Anmelden" setIsOpen={setIsOpen}>
          <Typography>Melden Sie sich an oder erstellen Sie Ihr kostenloses ntv-Konto:</Typography>

          <div className={styles.footer}>
            <button className="button secondary" onClick={createAcc}>
              Konto erstellen
            </button>
            <button className="button primary" onClick={onAgree}>
              Anmelden
            </button>
          </div>
          <Link href="https://finanzen.n-tv.de/etf-masterclass" target="_blank">
            <Typography as="span" variant="s">
              ntv ETF-Masterclass kaufen
            </Typography>
          </Link>
          <Link href={dpvAboLink} target="_blank">
            <Typography as="span" variant="s">
              Werbefrei mit dem PUR-Abo
            </Typography>
          </Link>
          <Link href="/newsletter/">
            <Typography as="span" variant="s">
              Newsletter abonnieren / verwalten
            </Typography>
          </Link>
        </Popup>
      )}
    </>
  )
}

export default LoginPopup
